/**
 * Checks if a given date is in the past.
 *
 * @param {Date} date - The date to check.
 * @returns {boolean} - Returns true if the date is in the past, otherwise false.
 */
export const isInPast = (date: Date) => {
  return date <= new Date()
}
